import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import search from "../assets/search.png"
import del from "../assets/del.png"
import change from "../assets/change.png"
import { socialdata } from '../posting/Socialarray'
import link from "../assets/share.png"
import user from "../assets/user.png"
import feed from "../assets/feed.png"
import barrow from "../assets/barrow.png"
import "./Media.css"


function MediaLibrary() {
  return (<>
    <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
      <Navbars />
      <div className='d-flex gap-5 pe-3 main_div'>
        <Sidebar />
        <div className='inner_div ps-3 pe-3 mb-5 pb-5' style={{marginTop:"85px"}}>
          <div className=' pe-3' style={{ position: "relative" }}>
            <input placeholder='Search Business id, Business name, Zip code etc ' className='add_search' />
            <img src={search} className="search_img" />
          </div>
          <div className='d-flex justify-content-end gap-2 flex-wrap align-items-center mt-4'>
            <img style={{ height: "20px" }} src={del} />
            <button className='label_div d-flex justify-content-center' style={{ border: "none", maxWidth: "100px", padding: "6px" }}>Select All</button>
            <div className='change_div'>
              <img src={change} />
            </div>
          </div>
          <div className='row'>
            <div className='d-flex w-100 gap-5 flex-wrap justify-content-between media_card_main' >
              {socialdata.map((value, index) => {
                return (<>
                  <div key={index} className=' col-lg-4 col-md-6 col-sm-12 user_card pb-2' style={{ width: "95%", maxWidth: "350px" }}>
                    <div className='d-flex gap-2 align-items-center'>
                      <img className='user_img' src={user} />
                      <div className='d-flex gap-2 justify-content-between w-100 flex-wrap'>
                        <p className='user_name'>Adam Person</p>
                        <p className="feed_time">7 min ago</p>
                      </div>
                    </div>
                    <p className='feed_text'>Lorem ipsum dolor sit amet consecte
                      tur. Malesuada sagittis ac ipsum eu
                      morbi ut aliquet.<span className='text_span'> @samuel </span> consecte.</p>

                    <img className='w-100 mb-2 mt-3 mb-2' src={feed} />
                    <div className='d-flex justify-content-between w-100 align-items-center'>
                      <div className='d-flex gap-3 align-items-center'>
                        <img src={barrow} />
                        <img src={value.image} />
                      </div>
                      <input className='radio_input' type="radio" />
                    </div>
                  </div>
                </>)
              })}
            </div>
          </div>
        </div>
      </div>
    </div>






  </>

  )
}

export default MediaLibrary